import { Checkbox, Form, Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { FIXED_POSITION_HINT } from 'shared/constants/rotation'

// «Не перемешивать»: закреплённый остаётся там, где стоит в списке
export const FixedPositionFields = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 24 }}>
    <Form.Item name='fixed_position' valuePropName='checked' noStyle>
      <Checkbox>Не перемешивать</Checkbox>
    </Form.Item>
    <Tooltip title={FIXED_POSITION_HINT}>
      <QuestionCircleOutlined style={{ color: 'rgba(0, 0, 0, 0.45)', cursor: 'help' }} />
    </Tooltip>
  </div>
)
